/****************************************************
 * Module Name:  addProcessModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import ProcessProxy from "../../utility/proxy/manager/processProxy";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddProcessModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newprocess: this.props.editOperation ? this.props.sourceData.name : "",
      newdescription: this.props.editOperation ? this.props.sourceData.description : "",
      newfullname: this.props.editOperation ? this.props.sourceData.fullname : "",
      newsequence: this.props.editOperation ? this.props.sourceData.sequence : "",

      showError: false,

      validateProcessPresentSpinner: false,
      showValidationMessage: false,
      processAvailable: true,

      processValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newprocess,
      description: this.state.newdescription,
      fullname: this.state.newfullname,
      sequence: this.state.newsequence
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateProcessPresent = (processEntered) => {
    if (!processEntered || processEntered.trim() === "") return;

    this.setState({
      validateProcessPresentSpinner: true,
    });

    ProcessProxy.CheckProcessAvailable(processEntered, (response) => {
      //if we got response that means process is present at backend
      if (response) {
        //ProcessName already present
        this.setState({
          validateProcessPresentSpinner: false,
          showValidationMessage: true,
          processAvailable: false,
        });
      } else {
        //ProcessName not available, so can be used
        this.setState({
          validateProcessPresentSpinner: false,
          showValidationMessage: true,
          processAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (!this.props.editOperation)
      return !this.state.showValidationMessage || !this.state.processAvailable;

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add process validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Process" : "Add New Process"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Process Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Process <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newprocess}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Process (required)"
                          placeholder="Enter Process"
                          value={this.state.newprocess}
                          autoFocus
                          onBlur={(e) =>
                            this.validateProcessPresent(this.state.newprocess)
                          }
                          onChange={(e) =>
                            this.setState({
                              newprocess: e.target.value,
                              showValidationMessage: false,
                              processValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Process Cannot be Empty",
                            })
                          }
                          helperText={this.state.processValidationError}
                          error={this.state.processValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateProcessPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.processAvailable ? (
                        <font color="green">Process available</font>
                      ) : (
                        <font color="red">Process not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Full Name</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Full Name"
                        placeholder="Enter Full Name"
                        value={this.state.newfullname}
                        onChange={(e) => this.setState({ newfullname: e.target.value })}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Sequence</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Sequence"
                        placeholder="Enter Sequence"
                        value={this.state.newsequence}
                        onChange={(e) =>
                          this.setState({ newsequence: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
